import styled from 'styled-components'
import Box from 'components/shared/Box'

export const Wrapper = styled(Box)`
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    box-shadow: inset 0 58px 46px -100px rgba(66, 68, 90, 1);
`
